import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import Lightbox from "react-image-lightbox";
import moment from "moment";

//import filter modal
import FilterModal from "../../components/Modal/FilterModal";

import {
  getRequest,
  postRequest,
  deleteRequest,
  putRequestForm,
  putRequest,
  postRequestForm,
} from "../../components/Common/Utils.js";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { change } from "redux-form";
import { id } from "date-fns/locale";
import DeliveryAgents from "components/Modal/DeliveryAgents";

const filterObj = {
  first_name: "",
  last_name: "",
  gender: "",
  email: "",
  phone: "",
  country: "",
  nationality: "",
  bookingCode: "",
  bookingDate: "",
  agentEmail: "",
};

const OrderSentManufacturer = (props) => {
  console.log("props", props);
  const [modal_center, setmodal_center] = useState(false);
  const [Bannerdata, setOrderdata] = useState([]);
  const [assingDeliveryModalData, setAssingDeliveryData] = useState({});
  const [loader, setLoader] = useState(false);
  const [searchText, setSearchText] = useState("");

  // const [value, setValue] = React.useState(10);
  const [sort, setsort] = React.useState("");
  const [sortOrder, setsortOrder] = React.useState("desc");
  const [sortOrderId, setsortOrderId] = React.useState(null);

  const [currentFPage, setCurrentFPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [sizePerPageOrg, setSizePerPage] = useState(10);
  const [image, setImage] = React.useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [model, setModel] = useState(false);
  const [filter, setFilter] = useState({ ...filterObj });
  const [activeTab, setActiveTab] = useState(""); // New state for active tab


  const closeModal = () => {
    setModel(false);
  };

  const toggleModel = () => {
    console.log("toggleModel", model);
    setModel(!model);
  };

  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === "pagination") {
      if (page != currentPage) {
        setCurrentPage(page);
        console.log("page", page);
      }
    }

    console.log("type", type);

    if (type === "search") {
      console.log("searchText", searchText);
    }
  };

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }


  const getFilters = () => {
    const filterArgs = [];

    Object.keys(filter).forEach((key) => {
      if (
        filter[key] !== "" &&
        filter[key] !== null &&
        filter[key] !== undefined
      ) {
        var filterObject = {
          [key]: filter[key],
        };

        if (key === "title") {
          filterObject.type = "regex";
        } else if (key === "homeBlockType") {
          filterObject.type = "eq";
        } else if (key === "sizeId") {
          filterObject.type = "obj-eq";
        } else if (key === "createdAt") {
          filterObject.type = "date-eq";
        }

        filterArgs.push(filterObject);
      }
    });
    return filterArgs;
  };

  const resetFilter = () => {
    setFilter({ ...filterObj });
    toggleModel();
    fetchOrderList();
  };

  function createdAtdata(cellContent, row) {
    return (
      <React.Fragment>
        <div>
          <p>{moment(row.createdAt).format("DD-MM-YYYY")} </p>
        </div>
      </React.Fragment>
    );
  }

  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };

  const handleDownload = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = image;
    downloadLink.download = "downloaded-image.jpg";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  function SNoFormatter(cellContent, row, i) {
    return <>{i + 1}</>;
  }

  function ProductPriceFormatter(cellContent, row) {
    const totalAmount = row?.totalAmount;
    const kuliesCommission = row?.kuliesCommission;

    const finalAmount = kuliesCommission ? totalAmount - kuliesCommission : totalAmount;

    return (
      <div className="d-flex gap-2">
        ${finalAmount}
      </div>
    );
  }

  function ProductCommPriceFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2">
        ${row?.kuliesCommission}
      </div>
    );
  }
  function OrderStatusFormatter(cellContent, row) {
    return (
      <div className="">
        <div className="status-order">
          <h5
            style={{
              color:
                row?.orderStatus === "pending" ? "#FFC107" : // Yellow
                  row?.orderStatus === "confirmed" ? "#4CAF50" : // Blue
                    row?.orderStatus === "cancelled" ? "#EC536C" : // Red
                      row?.orderStatus === "delivered" ? "green" : // Green
                        row?.orderStatus === "inTransit" ? "#FF9800" : // Orange
                          row?.orderStatus === "processing" ? "#673AB7" : // Purple
                            row?.orderStatus === "shipped" ? "#3F51B5" : // Dark Blue
                              row?.orderStatus === "outForDelivery" ? "#009688" : // Teal
                                row?.orderStatus === "failed" ? "#F44336" : // Dark Red
                                  "#4CAF50", // Default Green
            }}
          >
            {row?.orderStatus}
          </h5>
        </div>
      </div>
    );
  }
  function ManufacturerFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2 align-items-center">
        <div>
          <img src={row?.manufacturerDetails?.logo} width="50px" />
        </div>
        <div className="flex-product text-start">
          {row?.manufacturerDetails?.companyName}
          <br />
          Address : {row?.manufacturerDetails?.address}
          <br />
          <span className="text-capitalize" style={{ color: '#009fbc' }}>{row?.manufacturerDetails?.type}</span>
        </div>
      </div>
    );
  }
  function OrderDateFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2 align-items-center">
        {moment(row.createdAt).format("DD-MM-YYYY hh:mm")}
      </div>
    );
  }
  function InvoiceFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2 align-items-center">
        <a href={`${row?.invoice}`} target="_blank">{row?.invoiceId}</a>
      </div>
    );
  }
  function PaymentStatusFormatter(cellContent, row) {
    return (
      <div className="">
        <div className="status-order">
          <h5 style={{
            color: row?.adminPayStatus === 'completed' || row?.adminPayStatus === 'paid'
              ? '#4caf50'
              : row?.adminPayStatus === 'Cancelled'
                ? '#ec536c'
                : '#FFC107'
          }}>
            {row?.adminPayStatus}
          </h5>
        </div>
      </div>
    );
  }
  function redirectFormatter(cellContent, row) {
    return (
      <div className="">
        <Link
          to={{
            pathname: `/order-sent-manufacturer/${row?._id}`,
            state: { row },
          }}
        >
          {row?._id}
        </Link>
      </div>
    );
  }

  const columns = [
    {
      text: "S.NO",
      formatter: SNoFormatter,
      sort: false,
    },

    {
      text: "Order Id",
      sort: false,
      // dataField: "_id"
      formatter: redirectFormatter,
    },
    {
      text: "Invoice Id",
      sort: false,
      //dataField: "invoiceId"
      formatter: InvoiceFormatter,
    },
    // {
    //   text: "Product Info",
    //   sort: false,
    //   formatter: ProductImageFormatter,
    // },

    {
      text: "Manufacturer Info",
      sort: false,
      formatter: ManufacturerFormatter,
    },
    {
      text: "kulies Commission",
      sort: false,
      //dataField : 'totalAmount',
      formatter: ProductCommPriceFormatter,
    },
    {
      text: "Total Amount",
      sort: false,
      //dataField : 'totalAmount',
      formatter: ProductPriceFormatter,
    },


    // {
    //   // dataField: "orderStatus",
    //   text: "Payment Status",
    //   sort: false,
    //   formatter: PaymentStatusFormatter,
    // },
    {
      // dataField: "orderStatus",
      text: "Order Status",
      sort: false,
      formatter: OrderStatusFormatter,
    },
    {
      // dataField: "orderStatus",
      text: "Order Date",
      sort: false,
      formatter: OrderDateFormatter,
    },
    // {
    //   formatter: TotalAmountFormatter,
    //   //dataField: "totalAmount",
    //   text: "Total Amount",
    //   sort: false,
    // },
    {
      dataField: "actions",
      text: "Action",
      formatter: iconFormatter2,
      sort: false,
    },
  ];
  const handleChange = (event) => {
    setSizePerPage(event.target.value);
    if (currentPage != 1) {
      setCurrentPage(1);
    } else {
      fetchOrderList(null, event.target.value);
    }
  };
  // const handlesorting = (event) => {
  //   setsort(event.target.value);
  // };
  const handlesortOrder = (event) => {
    setsortOrder(event.target.value);
  };
  const handleReload = () => {
    setSearchText("");
    fetchOrderList();
    setActiveTab('');
  };


  const cancelOrder = async (_id) => {
    const payload = {
      orderId: _id,
      status: "cancelled"
    }
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to cancel this order?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, cancel it!',
      cancelButtonText: 'Close'
    });
    if (result.isConfirmed) {
      const res = await postRequest("order/update-status-by-admin", payload);
      if (res.status) {
        Swal.fire('Cancelled!', 'The order has been cancelled.', 'success');
        fetchOrderList();
      } else {
        Swal.fire('Error!', 'Something went wrong.', 'error');
        setLoader(false);
      }
    } else {
      //Swal.fire('Cancelled', 'The order was not cancelled.', 'info');
    }
  };

  const DeliveredOrder = async (_id, status) => {
    const payload = {
      orderId: _id,
      orderStatus: "delivered"
    }
    const confirmButtonText = status === "delivered" ? "Yes, mark as delivered!" : "Yes, mark as received!";

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'mark this order as delivered?',
      icon: 'warning',
      showCancelButton: true,
      showCancelButton: true,
      cancelButtonText: 'Close',
      confirmButtonText: confirmButtonText,
    });
    if (result.isConfirmed) {
      const res = await postRequest("order/update-status-by-admin", payload);
      if (res.status) {
        Swal.fire('Received!', 'Yes, mark as received!', 'success');
        fetchOrderList();
      } else {
        Swal.fire('Error!', 'Something went wrong.', 'error');
        setLoader(false);
      }
    } else {
      ///Swal.fire('Cancelled', 'The order was not cancelled.', 'info');
    }
  };

  function iconFormatter2(cellContent, row) {
    return (
      <>
        <div className="d-flex gap-2">
          {row?.status === 'pending' &&
            <div className="d-flex justify-content-center gap-2">
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => cancelOrder(row?._id)}
              >
                Cancel Order
              </button>
            </div>
          }
          {row?.orderStatus === 'inTransit' &&
            <div className="d-flex gap-2">
              <button
                type="button"
                style={{ whiteSpace: 'nowrap' }}
                className="btn btn-primary"
                onClick={() => DeliveredOrder(row?._id, "received")}
              >
                Mark as Received
              </button>
            </div>
          }
          <button type="button" className=" btn btn-primary">
            <Link
              to={{
                pathname: `/order-sent-manufacturer/${row?._id}`,
                state: { row },
              }}
            >
              <i className="fal fa-eye fs-5 text-light"></i>
            </Link>
          </button>
        </div>
      </>
    )
  }

  const limit = 10;

  const exportCSV = async () => {
    setLoader(true);

    const filterArgs = getFilters();
    const payload = {
      sortField: sort,
      sortOrder: sortOrder,
    };

    if (filterArgs?.length) {
      payload.filterArgs = filterArgs;
    } else {
      if (searchText) {
        payload.search = searchText;
      }
    }

    try {
      const response = await postRequest(`Banner/export-csv`, payload);
      const data = response.data;
      window.location.href = data.url;
      console.log("data", data);
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchOrderList = async (limit = null) => {
    console.log(currentPage);
    setLoader(true);
    const payload = {
      limit: limit ? limit : sizePerPageOrg,
      page: currentPage,
      sortField: sort,
      sortOrder: sortOrder,
      search: searchText,
      filterArgs: [
        {
          type: "regex",
          orderStatus: activeTab ? activeTab : ''
        },
      ],
    };
    try {
      const response = await postRequest(`order/admin-order-list`, payload);
      const data = response.data;

      setTotalPage(data.count);
      setCurrentFPage(currentPage);

      console.log("table data", data.bannerData);
      setOrderdata(data?.list);
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const closeModalDeleveryAgent = () => {
    setModel(false);
  };

  const selectRow = (item) => {
    console.log({ item })
    setAssingDeliveryData({
      Image: item?.image,
      Title: item?.title,
      categoryId: item?._id,
      show: true
    });
    setModel(false);
  };

  const handlesOrderType = (event) => {
    setActiveTab(event.target.value);
  };

  const orderStatusEnum = [
    "pending",
    "confirmed",
    "cancelled",
    "delivered",
    "inTransit",
  ];


  useEffect(() => {
    fetchOrderList();
  }, [currentPage]);

  useEffect(() => {
    fetchOrderList();
  }, [sort, sortOrder, activeTab]);


  return (
    <>
      <React.Fragment>
        <ToastContainer />
        <Row>
          <div className="col-md-6">
            <div className="page-title-box">
              <h4>Order Management</h4>

              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item active">Order Management</li>:{" "}
                <li className="breadcrumb-item">Order Sent to Manufacturer</li>
              </ol>
            </div>
          </div>
          <div className="col-md-6 text-end">
            {/* {canExport && (
              <button
                onClick={() => {
                  exportCSV();
                }}
                type="button"
                className="btn btn-primary mx-2"
              >
                <i class="fas fa-upload"></i> Export CSV
              </button>
            )} */}
            {/* <Link to="/createBanner">
              {" "}
              <Button>
                {" "}
                <i class="fas fa-plus"></i> Create
              </Button>{" "}
            </Link> */}
            &nbsp;&nbsp;&nbsp;
          </div>
          <Col className="col-12">
            <Card>
              {loader ? (
                <CardBody style={{ height: "100px" }}>
                  <Spinner
                    color="info"
                    style={{
                      height: "4rem",
                      width: "4rem",
                      position: "absolute",
                      left: "50%",
                    }}
                  >
                    Loading...
                  </Spinner>
                </CardBody>
              ) : (
                <CardBody className="table-shorting">
                  {
                    <PaginationProvider
                      pagination={paginationFactory({
                        page: currentFPage,
                        sizePerPage: sizePerPageOrg,
                        totalSize: totalPage,
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <ToolkitProvider
                            keyField="_id"
                            data={Bannerdata}
                            columns={columns}
                          >
                            {(props) => (
                              <Row>
                                <Col className="col-lg-12 d-flex mb-3">
                                  <label className="mb-0 text-label">
                                    Page Size
                                  </label>

                                  <select
                                    value={sizePerPageOrg}
                                    onChange={handleChange}
                                    className="form-select"
                                    style={{ width: "7%" }}
                                  >
                                    <option value="10">10</option>

                                    <option value="20">20</option>

                                    <option value="50">50</option>
                                  </select>

                                  {/* <label className="mb-0 text-label ms-3">
                                    Sort By:
                                  </label>
                                  <select
                                    value={sort}
                                    onChange={handlesorting}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="title">Title Name</option>

                                    <option value="type">Type Name </option>
                                  </select> */}
                                  <label className="mb-0 text-label ms-3">
                                    Sort Order:
                                  </label>
                                  <select
                                    value={sortOrder}
                                    onChange={handlesortOrder}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="asc"> Ascending</option>
                                    <option value="desc">Descending</option>
                                  </select>
                                  <div className="d-flex">
                                    <label className="mb-0 text-label ms-3">
                                      Order Type:
                                    </label>
                                    <select
                                      value={activeTab}
                                      onChange={handlesOrderType}
                                      className="form-select"
                                      style={{ width: "70%" }}
                                    >
                                      <option value=''>
                                        All Orders
                                      </option>
                                      {orderStatusEnum.map((status) => (
                                        <option key={status} value={status}>
                                          {status.charAt(0).toUpperCase() + status.slice(1)}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="filter-item">
                                    <input
                                      type="search"
                                      placeholder="Search"
                                      value={searchText}
                                      class="form-control"
                                      onChange={(e) =>
                                        setSearchText(e.target.value)
                                      }
                                      style={{ width: "30%" }}
                                    />
                                    <button
                                      onClick={() => {
                                        fetchOrderList();
                                      }}
                                      type="button"
                                      className="btn btn-primary mx-2"
                                    >
                                      Search
                                    </button>

                                    <button
                                      type="button"
                                      onClick={handleReload}
                                      className="btn btn-danger mx-2"
                                    >
                                      Reset
                                    </button>
                                    {/* <button
                                      type="button"
                                      onClick={toggleModel}
                                      className="btn btn-info"
                                    >
                                      Filter
                                    </button> */}
                                  </div>
                                </Col>

                                <Col className="col-lg-12 text-end">
                                  <BootstrapTable
                                    onTableChange={handleTableChange}
                                    remote={true}
                                    classes="table-striped"
                                    {...props.baseProps}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                            )}
                          </ToolkitProvider>

                          <Row>
                            <Col className="col-lg-12 text-end">
                              <div className="text-md-right">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>
        {openLightbox && (
          <>
            <Lightbox
              mainSrc={image}
              onCloseRequest={() => setOpenLightBox(false)}
              toolbarButtons={[
                <button
                  className="btn btn-primary"
                  key="download"
                  onClick={handleDownload}
                >
                  Download
                </button>,
              ]}
            />
          </>
        )}

        <DeliveryAgents
          show={model}
          closeModal={closeModalDeleveryAgent}
          selectRow={selectRow} />

      </React.Fragment>
      {/* <FilterModal
        show={model}
        closeModal={closeModal}
        components={components}
      /> */}
    </>
  );
};

export default OrderSentManufacturer;
